module.exports = __webpack_public_path__ + "img/12_klio_20.da45d633.jpg";